<div class="container">
  <mat-toolbar color="primary" class="toolbar-over-card">
    <mat-card-title>Edit Briefcase</mat-card-title>
  </mat-toolbar>
  <mat-card appearance="outlined" class="scrollable-content">
    <mat-card-content *ngIf="briefcase" [formGroup]="briefcaseFormGroup">
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <textarea matInput placeholder="Note title" cdkTextareaAutosize
                    formControlName="title"></textarea>
        </mat-form-field>
      </div>
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Description</mat-label>
          <textarea matInput placeholder="Note content" cdkTextareaAutosize
                    formControlName="comments" style="min-height: 100px;"></textarea>
        </mat-form-field>
      </div>
      <div class="form-control-wrapper">
        <mat-checkbox formControlName="isShared">Allow users without access to Lexbe to download this briefcase</mat-checkbox>
      </div>
      <div class="form-control-wrapper" style="margin-top: 10px;">
        <button mat-raised-button (click)="viewDocuments()" color="primary">
          <div class="document-button-text">
            <mat-icon>launch</mat-icon>
            <div>View Documents</div>
          </div>
        </button>
      </div>
    </mat-card-content>
    <mat-card-actions align="end" *ngIf="briefcase">
      <button mat-button color="primary" [disabled]="isSaveDisabled()" (click)="save()">Save</button>
      <button mat-button color="primary" (click)="cancel()">Cancel</button>
    </mat-card-actions>
  </mat-card>
</div>
